__turbopack_context__.v({
  "bar": "Slider-module__ALuH4W__bar",
  "label": "Slider-module__ALuH4W__label",
  "mark": "Slider-module__ALuH4W__mark",
  "markCustom": "Slider-module__ALuH4W__markCustom",
  "markLabel": "Slider-module__ALuH4W__markLabel",
  "markWrapper": "Slider-module__ALuH4W__markWrapper",
  "root": "Slider-module__ALuH4W__root",
  "thumb": "Slider-module__ALuH4W__thumb",
  "track": "Slider-module__ALuH4W__track",
  "trackContainer": "Slider-module__ALuH4W__trackContainer",
});
